import { getAuth } from "firebase/auth";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";

/**
 * Submit authenticated onboarding survey (landlord, first-impressions).
 * @param {object} payload - matches backend OnboardingSurveySubmitSchema
 */
export async function submitOnboardingSurvey(payload) {
  const user = getAuth().currentUser;
  if (!user) {
    throw new Error("You must be signed in to submit the survey.");
  }
  const token = await user.getIdToken();
  const res = await fetch(`${API_BASE_URL}/onboarding-survey`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Request failed (${res.status})`);
  }
  return data;
}
